/**
 * Fan Carousel — Efecto spread/abanico
 * Compatible con Shopify themes (Debut, Dawn, etc.)
 */

(function () {
  'use strict';

  // Configuración del spread
  const CONFIG = {
    // Cuántos slides mostrar a cada lado del activo
    visibleSides: 3,
    // Separación horizontal entre slides (px) por paso
    stepX: 160,
    // Escala por cada paso desde el centro
    scaleStep: 0.12,
    // Opacidad por cada paso desde el centro
    opacityStep: 0.18,
    // Rotación (deg) por cada paso — efecto abanico leve
    rotateStep: 0,        // pon 4 si quieres rotación tipo abanico
  };

  // ── Ajuste responsive de stepX
  function getStepX() {
    const w = window.innerWidth;
    if (w >= 1200) return 200;
    if (w >= 900)  return 170;
    if (w >= 600)  return 140;
    return 100;
  }

  function initCarousel(section) {
    const slides    = Array.from(section.querySelectorAll('.fan-carousel__slide'));
    const btnPrev   = section.querySelector('.fan-carousel__btn--prev');
    const btnNext   = section.querySelector('.fan-carousel__btn--next');
    const dots      = Array.from(section.querySelectorAll('.fan-carousel__dot'));
    const total     = slides.length;

    if (total === 0) return;

    let current = Math.floor(total / 2); // empieza en el central

    // ── Dibuja posiciones
    function render() {
      const stepX = getStepX();

      slides.forEach((slide, i) => {
        const offset = i - current;
        const absOff = Math.abs(offset);

        // Slides muy lejanos: ocultos
        if (absOff > CONFIG.visibleSides) {
          slide.style.opacity = '0';
          slide.style.pointerEvents = 'none';
          slide.style.zIndex = '0';
          slide.style.transform = `translateX(${offset * stepX}px) scale(0.4)`;
          return;
        }

        const scale   = 1 - absOff * CONFIG.scaleStep;
        const opacity = 1 - absOff * CONFIG.opacityStep;
        const x       = offset * stepX;
        const rotate  = offset * CONFIG.rotateStep;
        const z       = CONFIG.visibleSides + 1 - absOff;

        slide.style.transform   = `translateX(${x}px) scale(${scale}) rotate(${rotate}deg)`;
        slide.style.opacity     = opacity;
        slide.style.zIndex      = z;
        slide.style.pointerEvents = absOff === 0 ? 'auto' : 'auto';
      });

      // Dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    // ── Navegar
    function goTo(index) {
      current = ((index % total) + total) % total;
      render();
    }

    function prev() { goTo(current - 1); }
    function next() { goTo(current + 1); }

    // ── Eventos botones
    btnPrev && btnPrev.addEventListener('click', prev);
    btnNext && btnNext.addEventListener('click', next);

    // ── Eventos dots
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
    });

    // ── Click en slide lateral → navegar hacia él
    slides.forEach((slide, i) => {
      slide.addEventListener('click', (e) => {
        if (i === current) return; // es el central, deja que el link funcione
        e.preventDefault();
        goTo(i);
      });
    });

    // ── Swipe en móvil
    let touchStartX = 0;
    const track = section.querySelector('.fan-carousel__track-container');

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? next() : prev();
      }
    }, { passive: true });

    // ── Re-render en resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 120);
    });

    // ── Auto-play (opcional — descomenta si quieres)
    // let autoplay = setInterval(next, 4000);
    // section.addEventListener('mouseenter', () => clearInterval(autoplay));
    // section.addEventListener('mouseleave', () => { autoplay = setInterval(next, 4000); });

    // Render inicial
    render();
  }

  // ── Inicializar todas las instancias en la página
  function boot() {
    document.querySelectorAll('.fan-carousel-section').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Soporte para Shopify editor (secciones cargadas dinámicamente)
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.fan-carousel-section');
    if (section) initCarousel(section);
  });
})();
